import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AngularFirestore } from '@angular/fire/firestore';

import { Playlist } from '../../models';
import { BaseService } from './base-dataservice';
import { map } from 'rxjs/operators';

@Injectable()
export class PlaylistService extends BaseService<Playlist> {
  constructor(afs: AngularFirestore) {
    super('playlists', afs);
  }

  // Custom Methods

  getForUser(userId: string): Observable<Playlist[]> {
    const coll = this.afs.collection(this.uri, ref => ref.where('userId', '==', userId));

    return coll.snapshotChanges().pipe(
      map(changes => {
        return changes.map(a => {
          const data = a.payload.doc.data() as Playlist;
          data.id = a.payload.doc.id;
          return data;
        })
      })
    );
  }

  getForMatch(matchId: string): Observable<Playlist[]> {
    const coll = this.afs.collection(this.uri, ref => ref.where('matchId', '==', matchId));

    return coll.snapshotChanges().pipe(
      map(changes => {
        return changes.map(a => {
          const data = a.payload.doc.data() as Playlist;
          data.id = a.payload.doc.id;
          return data;
        });
      })
    );
  }
}
